import React, {useEffect, useRef} from 'react';
import styles from "./contact.module.css";
import texts from "../../assets/ContextProvider/textsLocalized.json";
import {useNavigate} from "react-router-dom";
import {scrollToTop} from "../../assets/AdditionalFunctions/ScrollToTop";
import Routes from "../../assets/Routes/Routes";
import {animateButtonPress} from "../../assets/AdditionalFunctions/AnimateButtonPress";

const Contact = () => {
  const navigate = useNavigate();
  const btnRef = useRef(null);


  useEffect(() => {
    scrollToTop();
  }, []);


  const handleNavigate = async () => {
    await animateButtonPress(btnRef, styles.pressed);
    navigate(-1);
  }


  return (
    <section className={styles['section_wrapper']}>
      <span className={styles['title']}>
        {texts.contact['title']}
      </span>
      <span className={styles['description']}>
        {texts.contact['description']}
      </span>
      <div className={styles["phone"]}>
        {texts.contact['phone']}
        <span className={styles["phone-value"]}>xxxx</span>
      </div>
      <div className={styles["email"]}>
        {texts.contact['email']}
        <span className={styles["email-value"]}>xxxx</span>
      </div>
      <button ref={btnRef}
              className={styles['btn-contact']}
              onClick={handleNavigate}>
        {texts.contact['contact-btn']}
      </button>
    </section>
  );
}

export default Contact;